/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  RegisterMutationRequest,
  RegisterMutationResponse,
} from '../types/Register'

function getRegisterUrl() {
  const res = { method: 'POST', url: `/api/v1/auth/registration/` as const }
  return res
}

/**
 * @description Registers a new user.
 * Accepts the following POST parameters: username, email, password1, password2.
 * @summary Register a new user
 * {@link /api/v1/auth/registration/}
 */
export async function register(
  data: RegisterMutationRequest,
  config: Partial<RequestConfig<RegisterMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    RegisterMutationResponse,
    ResponseErrorConfig<Error>,
    RegisterMutationRequest
  >({
    method: 'POST',
    url: getRegisterUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
